/** @jsx React.DOM */

var React = require("react/addons");

var TreeBox = require("editor/components/tree/TreeBox");
var EditorsBox = require("editor/components/editors/EditorsBox");
var TerminalsBox = require("editor/components/terminals/TerminalsBox");
var ContextMenu = require("editor/components/common/ContextMenu");
var Modal = require("editor/components/common/Modal");
var Loader = require("editor/components/common/Loader");
var RunnerBox = require("editor/components/RunnerBox");

var IdeActions = require("editor/actions/IdeActions");
var WatchStoreMixin = require("editor/mixins/WatchStore");
var IdeStore = require("editor/stores/IdeStore");

var Ide = React.createClass({displayName: 'Ide',
  mixins: [WatchStoreMixin(IdeStore)],
  getFluxState: function() {
    return IdeStore.getState();
  },

  handleGlobalClick: function() {
    IdeActions.globalClick();
  },

  render: function() {
    if (!this.state.isLoaded) {
      return Loader(null);
    }

    return (
      React.DOM.div(null, 
        ContextMenu(null), 
        Modal(null), 
        React.DOM.div({className: "row", onClick: this.handleGlobalClick}, 
          React.DOM.div({className: "col-md-3 file-tree-box"}, 
            RunnerBox(null), 
            TreeBox(null)
          ), 
          React.DOM.div({className: "col-md-9 tabs-box"}, 
            EditorsBox(null)
          )
        ), 
        React.DOM.div({className: "row"}, 
          React.DOM.div({className: "col-md-12 terminals-box"}, 
            TerminalsBox(null)
          )
        )
      )
    );
  }
});

module.exports = Ide;



/*****************
 ** WEBPACK FOOTER
 ** ./src/editor/components/Ide.js
 ** module id = 3
 ** module chunks = 0
 **/